import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const dark = tone === "dark";
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="mt-7 text-center" role="timer" aria-live="off" data-id="element-22" data-mp="3c3yysrhwio94">
      <p className={`flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-wider ${dark ? "text-white/80" : "text-rose"}`} data-id="element-23" data-mp="3h1qr3mmgkcdu">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="371zwlkxwdxdr" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-25" data-mp="10dejno4hx1u6">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-26" data-mp="15adbg00oswp7" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-27" data-mp="159byfq04204u">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-serif text-3xl font-bold tabular-nums md:h-20 md:w-20 md:text-4xl ${dark ? "bg-white text-ink" : "bg-ink text-white"}`} data-id="element-28" data-mp="y04yyajilyu7">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/70" : "text-inkSoft"}`} data-id="element-29" data-mp="12u97uzcccgxx">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-2xl font-bold md:pt-6 ${dark ? "text-white" : "text-ink"}`} aria-hidden="true" data-id="element-30" data-mp="k1f28w0ly16d">
                :
              </span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-2 text-xs ${dark ? "text-white/70" : "text-inkSoft"}`} data-id="element-31" data-mp="1vin3j8fyj16b">
        Limited-time launch pricing
      </p>
    </div>;
}